import React from "react";
import { DetailRow } from "./mapTaskValues";

// ----------------------------  Additional view rows  ----------------------------
// The use case's configured rows (Additional View tab), one per line; they replace
// the field rows where one of the tab's flag columns is true. Every row shows, a dash
// when its columns are missing or null. Shown as is; nothing is answered on them.

const ISO_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

/** "2026-10-01T12:30:00+00:00" -> local date and time; other text as is. */
export const formatValue = (value: string): string => {
  if (!ISO_TIME.test(value)) return value;
  const t = new Date(value);
  return isNaN(t.getTime()) ? value : t.toLocaleString();
};

interface DetailRowsProps {
  rows: DetailRow[];
  // shown instead when there is no row; nothing is rendered when omitted
  emptyText?: string;
}

export const DetailRows: React.FC<DetailRowsProps> = ({ rows, emptyText }) => {
  if (!rows.length)
    return emptyText ? <p style={{ fontSize: "1.125rem", color: "#9ca3af" }}>{emptyText}</p> : null;
  return (
    <div style={grid}>
      {rows.map((r, i) => (
        <div key={i} style={row}>
          <div style={rowLabel}>{r.label}</div>
          <div style={valueBox}>{r.value ? formatValue(r.value) : "\u2014"}</div>
        </div>
      ))}
    </div>
  );
};

// ----------------------------  Styles  ----------------------------

const grid: React.CSSProperties = { display: "flex", flexDirection: "column", gap: "10px" };

const row: React.CSSProperties = { display: "flex", flexDirection: "column", gap: "4px" };

const rowLabel: React.CSSProperties = {
  fontSize: "1.2rem",
  fontWeight: 600,
  color: "#6b7280",
};

const valueBox: React.CSSProperties = {
  background: "#f0fdfa",
  border: "1px solid #ccfbf1",
  borderRadius: "6px",
  padding: "10px 12px",
  fontSize: "1.3rem",
  lineHeight: 1.6,
  color: "#1f2937",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  maxHeight: "300px",
  overflowY: "auto",
};
